var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0576 46.3906C35.7602 46.3906 46.0576 36.0932 46.0576 23.3906C46.0576 10.6881 35.7602 0.390625 23.0576 0.390625C10.3551 0.390625 0.0576172 10.6881 0.0576172 23.3906C0.0576172 36.0932 10.3551 46.3906 23.0576 46.3906Z",
    fill: "url(#paint0_linear_1743_2230)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9438 10.6128H18.1816C13.8269 10.6128 10.29 14.1497 10.29 18.5043V28.2666C10.29 32.6212 13.8269 36.1581 18.1816 36.1581H27.9438C32.2985 36.1581 35.8354 32.6212 35.8354 28.2666V18.5043C35.8354 14.1497 32.2985 10.6128 27.9438 10.6128ZM32.9834 28.2768C32.9834 31.0572 30.7243 33.3266 27.9336 33.3266H18.1714C15.3909 33.3266 13.1216 31.0675 13.1216 28.2768V18.5146C13.1216 15.7341 15.3807 13.4648 18.1714 13.4648H27.9336C30.714 13.4648 32.9834 15.7239 32.9834 18.5146V28.2768Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0574 16.8584C19.4592 16.8584 16.5254 19.7922 16.5254 23.3904C16.5254 26.9886 19.4592 29.9224 23.0574 29.9224C26.6556 29.9224 29.5894 26.9886 29.5894 23.3904C29.5894 19.7922 26.6556 16.8584 23.0574 16.8584ZM23.0574 27.3566C20.8698 27.3566 19.0912 25.578 19.0912 23.3904C19.0912 21.2028 20.8698 19.4242 23.0574 19.4242C25.2449 19.4242 27.0236 21.2028 27.0236 23.3904C27.0236 25.578 25.2449 27.3566 23.0574 27.3566Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0865 17.5744C30.6883 17.4769 31.097 16.9099 30.9995 16.3081C30.9019 15.7063 30.335 15.2976 29.7332 15.3951C29.1314 15.4927 28.7226 16.0596 28.8202 16.6614C28.9178 17.2632 29.4847 17.672 30.0865 17.5744Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1743_2230",
    x1: 5.5448,
    y1: 40.9034,
    x2: 38.2304,
    y2: 8.21788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0518459,
    stopColor: "#FEDB16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1381,
    stopColor: "#FEC125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2481,
    stopColor: "#FE983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#FE5F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE2181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9000DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c6dde329676ebfb2fc733dc56791b899.svg";
export { ForwardRef as ReactComponent };